import { baseApi } from './baseApi'
import { ICategory } from '../../types/categories'
import { ICategoryParams } from '../../types/app'

export const categoriesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<ICategory[], void>({
      query: () => '/categories',
      providesTags: ['Categories'],
    }),
    getCategoryById: builder.query<ICategory, string>({
      query: (id) => `/categories/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Categories', id }],
    }),
    createCategory: builder.mutation<ICategory, ICategoryParams>({
      query: (params) => ({
        url: '/categories',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Categories'],
    }),
    deleteCategory: builder.mutation<void, string>({
      query: (id) => ({
        url: `/categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Categories'],
    }),
    editCategory: builder.mutation<
      ICategory,
      { params: ICategoryParams; id: string }
    >({
      query: ({ params, id }) => ({
        url: `/categories/${id}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['Categories'],
    }),
  }),
})

export const {
  useGetCategoriesQuery,
  useGetCategoryByIdQuery,
  useCreateCategoryMutation,
  useDeleteCategoryMutation,
  useEditCategoryMutation,
} = categoriesApi
